const Features = {
    PermissionsV2: {
        GROUPMODAL: 'Zocalo.PermissionsV2.UI.GroupModal',
        COOWNERSHIP: 'Zocalo.PermissionsV2.UI.Coownership',
        SUBFOLDERSHARE: 'Zocalo.PermissionsV2.UI.SubfolderShare'
    },
    UI: {
        FEEDBACK_AT_MENTIONS: 'Workdocs.Service.Mentions.Notifications',
        ENABLE_REQUEST_ACCESS: 'Workdocs.Service.EnableCreateAccess',
        CHECKIN_CHECKOUT: 'Workdocs.Service.CheckinCheckout',
        FRICTIONLESS_EDIT: 'WorkDocs.FrictionlessEdit',
        COMPANION_TERMINATION_SWITCH: 'WorkDocs.CompanionTerminationSwitch',
        COMPANION_DOWNLOAD_TERMINATION_SWITCH: 'WorkDocs.CompanionDownloadTerminationSwitch',
        SHOW_SITE_SWITCH: 'WorkDocs.UI.SiteSwitchPrompt',
        DISABLE_TYPEAHEAD_DURING_INVITE: 'WorkDocs.UI.DisableTypeaheadDuringInvite',
        FAVORITES: 'WorkDocs.UI.FAVORITES',
        SHARED_BY_ME: 'WorkDocs.UI.SharedByMe',
        PREVIEW_SITE: 'Workdocs.UI.PreviewSite',
        NOVA_ENABLED: 'Workdocs.UI.NovaEnabled',
        NOVA_ENABLED_AWS: 'Workdocs.UI.NovaEnabled_ForAWS',
        NOVA_ENABLED_AMAZON_CORP_SITE: 'Workdocs.UI.NovaEnabled_ForAmazonCorpSite',
        NOVA_KILL_SWITCH: 'Workdocs.UI.NovaKillSwitch',
        QUARTZ_ENABLED: 'Workdocs.UI.Quartz',
        QUARTZ_KILL_SWITCH: 'Workdocs.UI.QuartzKillSwitch',
        QUARTZ_ENABLED_AWS: 'Workdocs.UI.QuartzEnabled_ForAWS',
        QUARTZ_ENABLED_AMAZON_CORP_SITE: 'Workdocs.UI.QuartzEnabled_ForAmazonCorpSite',
        MARKETPLACE_LINK: 'Workdocs.UI.MARKETPLACE_LINK',
        ANALYTICS_LINK: 'Workdocs.UI.Analytics_Link',
        ANALYTICS_DASHBOARD_LINK: 'Workdocs.UI.Analytics_Dashboard_Link',
        ANONYMOUS_LINK: 'WorkDocs.Service.AnonymousSharing',
        EDIT_POWERUSER: 'WorkDocs.UI.PowerUser',
        ENABLE_LINK: "WorkDocs.UI.DisableLink",
        INVITE_POWERUSER: 'WorkDocs.UI.Invite_PowerUser',
        ADMIN_WORKDRIVES_LINK: 'Workdocs.UI.Admin_workdrives_link',
        EXTERNAL_SHARE: 'Workdocs.UI.External_Share',
        DISABLE_NOTIFICATIONS: "WorkDocs.Service.ResourceSpecificConfiguration",
        MINIMAL_USER: "WorkDocs.Service.MinimalUser",
        IMAGE_NAV: "WorkDocs.UI.IMAGE_NAV",
        RECOVERY_FOLDER: "WorkDocs.UI.ResourceRecovery",
        DidYouKnowMessages: "WorkDocs.UI.DidYouKnowMessages",
        FolderDownload: "WorkDocs.UI.FolderDownload",
        ExportActivityFeed: "WorkDocs.UI.ExportActivityFeed",
        HANCOM_ADD_DELAY: "WorkDocs.UI.isHancomDelayEnabled",
        ExportUserList: "WorkDocs.UI.ExportUserList",
        THUMBNAIL_VIEW: "WorkDocs.UI.ThumbnailView",
        SHOW_COMPANION_UPDATE_MODAL: "WorkDocs.UI.ShowCompanionUpdateModal",
        SHOW_EDIT_DROPDOWN: "WorkDocs.UI.ShowEditDropdown",
        SHOW_HDRIVE_MIGRATION: "WorkDocs.UI.ShowHDriveMigration",
        SEARCH_V2: "WorkDocs.UI.SearchV2_UI",
        IP_WHITELISTING: "WorkDocs.UI.IPWhitelisting",
        SHOW_TASKS: "WorkDocs.UI.TasksFeature",
        DISABLE_CONTACT_ADMIN_TASKS: "WorkDocs.UI.DisableContactAdminTasksFeature",
        FEATURE_NOTIFICATION: "WorkDocs.UI.FeatureNotification",
        RIGHT_CLICK_MENU: 'WorkDocs.UI.RIGHT_CLICK_MENU',
        DASHBOARD_HOME: "WorkDocs.UI.DashboardHome",
        EXT_MULTI_SELECT_ACTIONS_IN_FILE_BROWSER: "WorkDocs.UI.ExtMultiSelectActionsInFileBrowser",
        INGRESS_MODAL: 'WorkDocs.UI.IngressModal',
        VERSION_PURGE: "WorkDocs.UI.VersionPurge",
        APPROVAL: 'WorkDocs.UI.Approval',
        APPROVAL_V2_DISABLED: 'WorkDocs.UI.ApprovalV2Disabled',
        MEETINGS: 'WorkDocs.UI.Meetings',
        MIGRATIONS_DISABLED: 'WorkDocs.UI.MigrationsDisabled',
        TEXTTOVOICE: 'WorkDocs.UI.TextToVoice',
        CHATBOT: 'WorkDocs.UI.ChatBot',
        CLASSIFICATIONS: 'WorkDocs.UI.Classifications',
        AUDIT_EMAIL: 'WorkDocs.UI.AuditEmail',
        ENFORCE_EXP_DATE_ON_LINK_SHARING: 'WorkDocs.UI.EnforceExpDateOnLinkSharing',
        VERSION_DELETE: 'WorkDocs.UI.VersionDelete',
        FORWARDING_SERVICE: 'WorkDocs.UI.ForwardingService',
        DISABLE_NOTIFY_CONTRIBUTORS: 'WorkDocs.UI.DisableNotifyContributors',
        DISABLE_INHERITED_FILE_SHARE: 'WorkDocs.UI.DisableInheritedFileShare',
        REDIRECT_DILIP_REPORTS: 'WorkDocs.UI.RedirectDilipReports',
        REDIRECT_AMAZON_SITE: 'WorkDocs.UI.RedirectAmazonSite',
        REDIRECT_OFFICIAL_NOVA_AMAZON_WORKDOCS_SITE: 'WorkDocs.UI.RedirectOfficialNovaAmazonWorkDocsSite',
        REDIRECT_ALL_INTERNAL_SITES: 'WorkDocs.UI.RedirectAllInternalSites',
        NOVA_REDIRECT_BANNER_VISIBLE: 'WorkDocs.UI.NovaRedirectBanner'
    },
    DocumentViewer: {
        DOC_NAV: 'WorkDocs.DocumentViwer.DocNav',
        PURGE_VERSIONS: 'WorkDocs.DocumentViwer.PurgeVersions',
        NOTES: 'WorkDocs.DocumentViewer.NOTES',
        ONLINENOTES: 'WorkDocs.DocumentViewer.OnlineNotes',
        O365: 'WorkDocs.DocumentViewer.O365',
        ONLINEEDITING: 'WorkDocs.DocumentViewer.OnlineEditing',
        NativeRendering: 'WorkDocs.DocumentViewer.NativeRendering'
    },
    Companion: {
        CLIPBOARD_HANDSHAKE: 'WorkDocs.Companion.ClipboardHandshake'
    },
    Desktop: {
        DESKTOP_APP_EDIT: 'WorkDocs.DesktopApp.Edit',
        DESKTOP_APP_NO_EDIT_SHARE_LINK: "WorkDocs.DesktopApp.NoEditShareLink"
    }
};

// Register all constants handled by this module
angular.module('GorillaBoy.FeatureManager')
    .constant('Features', Features);

export default Features;
